var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1225_91227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.8402 111.05C93.6094 113.316 90.0285 115.05 86.2347 116.185L72.9179 120.171C51.8803 126.468 30.8497 109.98 32.1755 88.2297C32.4807 83.222 31.5617 78.2084 29.4964 73.6139L23.5011 60.2771C14.0492 39.2508 27.7484 15.2739 50.7638 12.5609C67.1081 10.6343 82.6169 20.4137 87.8096 35.9209L88.3503 37.5357C90.6841 44.505 95.41 50.4556 101.704 54.3495C120.894 66.2226 121.799 93.547 103.429 106.43L96.8402 111.05Z",
    fill: "url(#paint0_linear_1225_91227)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9085 38.0346C56.0029 38.0346 59.3221 34.7585 59.3221 30.7173C59.3221 26.676 56.0029 23.3999 51.9085 23.3999C47.814 23.3999 44.4948 26.676 44.4948 30.7173C44.4948 34.7585 47.814 38.0346 51.9085 38.0346ZM51.9085 39.0103C56.5489 39.0103 60.3106 35.2974 60.3106 30.7173C60.3106 26.1372 56.5489 22.4242 51.9085 22.4242C47.2681 22.4242 43.5063 26.1372 43.5063 30.7173C43.5063 35.2974 47.2681 39.0103 51.9085 39.0103Z",
    fill: "#8494B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5524 31.7686H51.4437L51.2866 27.1678H52.7095L52.5524 31.7686ZM51.9981 32.4891C52.2229 32.4891 52.4031 32.5544 52.5386 32.6851C52.6772 32.8159 52.7465 32.983 52.7465 33.1867C52.7465 33.3873 52.6772 33.553 52.5386 33.6837C52.4031 33.8144 52.2229 33.8798 51.9981 33.8798C51.7763 33.8798 51.5961 33.8144 51.4575 33.6837C51.322 33.553 51.2543 33.3873 51.2543 33.1867C51.2543 32.9861 51.322 32.8204 51.4575 32.6897C51.5961 32.5559 51.7763 32.4891 51.9981 32.4891Z",
    fill: "#8494B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.106 96.4453C125.692 96.4453 127.788 94.3762 127.788 91.8238C127.788 89.2714 125.692 87.2023 123.106 87.2023C120.52 87.2023 118.423 89.2714 118.423 91.8238C118.423 94.3762 120.52 96.4453 123.106 96.4453ZM123.106 97.0615C126.036 97.0615 128.412 94.7165 128.412 91.8238C128.412 88.9311 126.036 86.5861 123.106 86.5861C120.175 86.5861 117.799 88.9311 117.799 91.8238C117.799 94.7165 120.175 97.0615 123.106 97.0615Z",
    fill: "#BCC1CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.512 92.4878H122.812L122.713 89.5821H123.611L123.512 92.4878ZM123.162 92.9428C123.304 92.9428 123.418 92.9841 123.504 93.0667C123.591 93.1492 123.635 93.2548 123.635 93.3835C123.635 93.5102 123.591 93.6148 123.504 93.6974C123.418 93.7799 123.304 93.8212 123.162 93.8212C123.022 93.8212 122.908 93.7799 122.821 93.6974C122.735 93.6148 122.692 93.5102 122.692 93.3835C122.692 93.2567 122.735 93.1521 122.821 93.0696C122.908 92.9851 123.022 92.9428 123.162 92.9428Z",
    fill: "#BCC1CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.873 107.1H80.8867C81.0017 107.1 81.0948 107.192 81.0948 107.306C81.0948 112.978 76.4363 117.576 70.6897 117.576H36.873V107.1Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 48.8546C11.6666 47.5157 12.7663 46.4303 14.1228 46.4303H61.8344C63.1909 46.4303 64.2906 47.5157 64.2906 48.8546V109.721C64.2906 111.763 65.3323 113.668 67.062 114.788L71.366 117.576H20.8771C15.7903 117.576 11.6666 113.506 11.6666 108.485V48.8546Z",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 16.0887,
    y: 54.7234,
    width: 41.5685,
    height: 4.36475,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 16.0887,
    y: 63.4529,
    width: 16.3621,
    height: 4.36474,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 16.0887,
    y: 72.1823,
    width: 16.3621,
    height: 4.36475,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 16.0887,
    y: 80.9119,
    width: 16.3621,
    height: 4.36476,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 16.0887,
    y: 89.6413,
    width: 41.5685,
    height: 4.36474,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 16.0887,
    y: 98.3708,
    width: 41.5685,
    height: 4.36473,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.662,
    y: 63.4529,
    width: 22.9953,
    height: 21.8237,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.526 75.0684L39.5264 80.0389H53.2351L50.8159 72.1823L47.1065 76.9924L44.526 75.0684Z",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.5163,
    cy: 70.2182,
    rx: 1.98998,
    ry: 1.96414,
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.501 70.3644H81.2348C81.1574 70.3644 81.0947 70.4264 81.0947 70.5028C81.0947 74.3231 84.2324 77.4201 88.103 77.4201H113.501V70.3644Z",
    fill: "#8494B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.374 31.3956C128.374 30.0567 127.274 28.9714 125.918 28.9714H94.9942C93.6377 28.9714 92.5381 30.0567 92.5381 31.3956V71.0273C92.5381 73.0693 91.4963 74.9739 89.7667 76.0943L87.7198 77.4201H119.163C124.25 77.4201 128.374 73.3499 128.374 68.3292V31.3956Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 28.302,
    height: 6.11064,
    rx: 2,
    transform: "matrix(-1 0 0 1 125.317 34.6456)",
    fill: "#D1D7E2"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 18.5732,
    height: 2.61886,
    transform: "matrix(-1 0 0 1 123.548 36.3914)",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.552,
    cy: 37.7009,
    rx: 1.76887,
    ry: 1.7459,
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 28.302,
    height: 6.11065,
    rx: 2,
    transform: "matrix(-1 0 0 1 125.317 42.0656)",
    fill: "#D1D7E2"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 18.5732,
    height: 2.61885,
    transform: "matrix(-1 0 0 1 123.548 43.8115)",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.552,
    cy: 45.121,
    rx: 1.76887,
    ry: 1.74589,
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 28.302,
    height: 6.11065,
    rx: 2,
    transform: "matrix(-1 0 0 1 125.317 49.4857)",
    fill: "#D1D7E2"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 18.5732,
    height: 2.61885,
    transform: "matrix(-1 0 0 1 123.548 51.2316)",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.552,
    cy: 52.541,
    rx: 1.76887,
    ry: 1.7459,
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 28.302,
    height: 6.11066,
    rx: 2,
    transform: "matrix(-1 0 0 1 125.317 56.9058)",
    fill: "#D1D7E2"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 18.5732,
    height: 2.61885,
    transform: "matrix(-1 0 0 1 123.548 58.6517)",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.552,
    cy: 59.9611,
    rx: 1.76887,
    ry: 1.7459,
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.1491,
    cy: 92.4242,
    rx: 3.22369,
    ry: 3.33334,
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.2149,
    cy: 112.273,
    rx: 1.84211,
    ry: 1.66666,
    fill: "#E2E5EB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.364,
    cy: 33.1818,
    rx: 2.76316,
    ry: 2.87879,
    fill: "#E2E5EB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.2544,
    cy: 51.3636,
    rx: 5.06578,
    ry: 5,
    fill: "#E2E5EB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.6535,
    cy: 33.0303,
    rx: 1.53509,
    ry: 1.51515,
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1225_91227",
    x1: 33.2135,
    y1: 59.9411,
    x2: 118.58,
    y2: 99.0391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D7E2",
    stopOpacity: 0.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1225_91227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.6d96058be2515e72840f50a09fa97664.svg";
export { ForwardRef as ReactComponent };